module.exports = __webpack_public_path__ + "img/bag.3259fed6.svg";